import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import { db, balaCollection, userDataCollection } from "@/firebase";
import { Module } from "@/store/enums.ts";
import WritingTask1Planning from "@/views/bala/writing_task_1/Planning.tsx";
import "@/styles/util.css";

@Component
export default class WritingTask1Response extends Vue {
  planningDialog = { open: false };
  valid = true;
  states = [
    {
      title: "How should Children use Social Media?",
      prompt:
        "Describe some good and bad things about social media and suggest how children should use it. Use examples from the video and your own ideas from the planning section. Make sure that:",
      writingGuidelines: [
        "Your response has an introduction, body, and conclusion. ​",
        "You use full sentences and paragraphs.​",
        "You try to write as much as you can."
      ]
    },
    {
      title: "Check your writing",
      prompt: "Now that you’ve finished your writing:",
      writingGuidelines: [
        "Check your spelling and punctuations.",
        "Check if you answered the question asked.",
        "Check if your main ideas are clear and supported by examples."
      ]
    }
  ];
  private title: string;
  private passagePrompt: string;
  private writingGuidelines: Array<string>;

  response = "";
  hasSubmitted = false;

  private _questions: any; // only 1 question

  constructor() {
    super();
    this._questions = this.$store.getters.balaWResponse.writingTask1;
    this.title = this.states[0].title;
    this.passagePrompt = this.states[0].prompt;
    this.writingGuidelines = this.states[0].writingGuidelines;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balaWResponse.writingTask1;
  }

  submit() {
    if (this.isComplete()) {
      this.$router.push({ name: "balaWT1Rating" });
      return;
    }
    if (this.hasSubmitted) {
      this._questions[0].answer["afterEdit"] = this.response;
      this.submitData();
    } else {
      this._questions[0].answer["beforeEdit"] = this.response;
      this.hasSubmitted = true;
      this.writingGuidelines = this.states[1].writingGuidelines;
      this.title = this.states[1].title;
      this.passagePrompt = this.states[1].prompt;
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item: any) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return this.$store.getters.balaSections[7].sectionProgress.Response == 100;
  }

  submitData() {
    if (this.$store.getters.balaSections[7].sectionProgress.Response != 100) {
      var thisUser = this.$store.getters.user;
      var uid = thisUser.data.uid;

      let timepoint = this.$store.getters.balaTimepointStr;
      let data = this.getData();

      // Store question answers
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("writingTask1")
        .set(
          {
            ResponseAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.writingTask1.response": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {});

      // Update progress in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Writing Task 1",
        subsection: "Response"
      });
    }

    this.$router.push({ name: "balaWT1Rating" });
  }

  setPassage() {
    this.$store.commit("setBalaWT1Passage", this.response);
  }

  private dataLoaded() {
    return this.$store.getters.balaWResponse.writingTask1Loaded;
  }

  private setResponse() {
    if (this.isComplete()) {
      this.response = this._questions[0].answer["afterEdit"];
    }
    return true;
  }

  render(h: CreateElement) {
    return (
      this.dataLoaded() &&
      this.setResponse() && (
        <Card
          title={this.title}
          mod={Module.BALA}
          topButton={{
            label: "My Planning",
            callbackfn: () => {
              this.planningDialog.open = true;
            }
          }}
        >
          <div slot="mainContent">
            <v-dialog
              v-model={this.planningDialog.open}
              content-class="cardDialog"
            >
              <WritingTask1Planning
                dialogMode={true}
                closeDialog={this.planningDialog}
              ></WritingTask1Planning>
            </v-dialog>
            <p>{this.passagePrompt}</p>
            <ul>
              {this.writingGuidelines.map(object => (
                <li>
                  <p>{object}</p>
                </li>
              ))}
            </ul>
            <hr></hr>
            <v-form v-model={this.valid}>
              <v-textarea
                class="mx-4"
                v-model={this.response}
                onChange={this.setPassage}
                rows="15"
                counter
                disabled={this.isComplete()}
                placeholder="Start writing here..."
                rules={[
                  (v: any) =>
                    (v.length > 0 && v.length < 2500) || "Max 500 words"
                ]}
              ></v-textarea>
            </v-form>
          </div>
          <div slot="actions">
            <v-spacer></v-spacer>
            <v-btn
              disabled={!this.valid}
              color="secondary"
              onClick={this.submit}
            >
              {this.isComplete()
                ? "Next"
                : this.hasSubmitted
                ? "Submit"
                : "Next"}
            </v-btn>
          </div>
          <div slot="progressBar">
            <v-spacer></v-spacer>
            <v-progress-linear
              value={Math.round(
                (this.$store.getters.progressBala /
                  this.$store.getters.numBalaQuestions) *
                  100
              )}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </div>
        </Card>
      )
    );
  }
}

const component = WritingTask1Response;
